module.exports = __webpack_public_path__ + "fonts/fs_lola-bold-webfont.7a928250.woff2";